export default __webpack_public_path__ + "static/media/Banner@1x.png?.dd95333f";